import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { apiClient } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);

  const fetchCustomers = () => apiClient.get("/admin/customers").then((res) => setCustomers(res.data));
  useEffect(() => { fetchCustomers(); }, []);

  const handleDelete = async (c) => {
    if (!window.confirm(`Delete customer "${c.name}" (${c.email})? This cannot be undone.`)) return;
    try {
      await apiClient.delete(`/admin/customers/${c._id}`);
      toast.success("Customer deleted");
      fetchCustomers();
    } catch {
      toast.error("Could not delete customer");
    }
  };

  return (
    <div data-testid="admin-customers-page">
      <h1 className="text-2xl font-display font-semibold text-slate-900 mb-6">Customers</h1>
      <div className="bg-white border border-slate-200 rounded-md shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-slate-600">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-3">Name</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Company / Institution</th><th className="px-4 py-3">Joined</th><th className="px-4 py-3"></th></tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c._id} className="border-t border-slate-100" data-testid={`admin-customer-row-${c._id}`}>
                <td className="px-4 py-3 font-medium text-slate-900">{c.name}</td>
                <td className="px-4 py-3">{c.email}</td>
                <td className="px-4 py-3">{c.company || "—"}</td>
                <td className="px-4 py-3">{new Date(c.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-3 text-right">
                  <Button size="sm" variant="outline" onClick={() => handleDelete(c)} data-testid={`admin-delete-customer-${c._id}`}>
                    <Trash2 className="h-3.5 w-3.5 text-red-500" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {customers.length === 0 && <p className="p-6 text-center text-slate-400 text-sm" data-testid="admin-no-customers">No customers yet.</p>}
      </div>
    </div>
  );
}
